// extracted by mini-css-extract-plugin
export default {"label":"InputRegulationsAgree-module--label--oPawG"};